import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { AbstractControl, Validators } from "@angular/forms";

@Component({
    selector: "app-toggle-switch",
    templateUrl: "./toggle-switch.component.html",
    styleUrls: ["./toggle-switch.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ToggleSwitchComponent implements OnInit {
  @Input() label: string = "";
  @Input() control: AbstractControl | null = null;
  @Input() required: boolean = false;
  @Input() dataId?: string;

  ngOnInit() {
    if (!this.control) {
      return;
    }
    if (this.required) {
      this.control.setValidators(Validators.requiredTrue);
      this.control.updateValueAndValidity();
    }
  }

  get isDisabled(): boolean {
    return this.control?.disabled ?? false;
  }

  toggle() {
    if (this.isDisabled || !this.control) return;
    this.control.setValue(!this.control.value);
  }
}
